// @flow
import {action, observable} from 'mobx'
import {notification} from 'antd'
import {List} from './list'
import {Single} from './single'
import Validator from 'validatorjs'

import {Store} from 'Store'
import {Api} from 'Store/api'

export class AlgoStore {
  root: Store
  api: Api
  list: List
  single: Single
  @observable selectedRows = []
  @observable preparingBacktest = false
  @observable validatingSignal = false
  @observable errors = {}

  constructor(rootStore: Store, api: Api) {
    this.root = rootStore
    this.api = api
    this.list = new List(this.root, this.api)
    this.single = new Single(this.root, this.api)
  }

  @action async runBacktest() {
    const backtestID = this.single.data.backtest.id
    this.root.redirectTo({pathname: `/backtest/algo/${backtestID}`})
    this.preparingBacktest = false
  }

  @action async updateAndRun() {
    this.preparingBacktest = true
    try {
      await this.single.update()
      this.runBacktest()
    } catch (e) { //eslint-disable-line
      this.preparingBacktest = false
    }
  }

  @action async createAndRun() {
    this.preparingBacktest = true
    try {
      await this.single.create()
      this.runBacktest()
    } catch (e) { //eslint-disable-line
      this.preparingBacktest = false
    }
  }

  @action async delete() {
    this.list.loading = true
    const ids = this.selectedRows.map(row => row.id)
    try {
      await this.api.request('sys/algos/delete', 'post', {ids: ids})
      this.list.load()
      this.root.backtest.list.load()
    } catch (e) {
      notification['error']({
        message: 'Failed to delete',
        description: e.message || 'Unknown error'
      })
    } finally {
      this.list.loading = false
    }
  }

  @action async validateSignal(signal_type: string) {
    if (!this.single[signal_type]) {
      return
    }
    let arr = this.single[signal_type].text.split(' ')
    if (arr[arr.length - 1].match(/@|#|&/)) {
      return
    }
    this.validatingSignal = true
    let body = {}
    body.signal = this.single[signal_type].text
    body.has_coin = this.single.data.has_coin
    try {
      await this.api.request('sys/algos/validate', 'post', body)
    } catch (e) {
      this.single.errors[signal_type] = e.message
    } finally {
      this.validatingSignal = false
    }
  }

  @action validateMain() {
    const rules = {
      signal: 'required',
      trade_type: 'required',
      trade_value: 'required',
      tickers: 'required_without:stock_filter',
      stock_filter: 'required_without:tickers'
    }
    const {tickers, signal: defaultSignal, ...data} = this.single.data // eslint-disable-line no-unused-vars
    const signal = this.single.signal.text
    const dataToValidate = {tickers:tickers.concat(', '), signal, ...data}
    const validation = new Validator(dataToValidate, rules)
    const passed = validation.passes()
    if (!passed) {
      this.errors = validation.errors.all()
    }
    return passed
  }
}
